// extracted by mini-css-extract-plugin
export default {"menuItem":"core-help-menu-styles-helpMenu-module__menuItem--P01NuzudCvnwSs3UoRl70g=="};